import Page from 'src/components/page/Page';
import { useParams } from '@tanstack/react-router';
import SalesOrderView from '../sales-orders/components/SalesOrderView';
import useSalesOrder from 'src/api/accounts-receivable/sales-orders/useSalesOrder';
import MDBox from 'src/components/md/MDBox';
import { CircularProgress } from '@mui/material';
import ErrorMessage from 'src/components/errorMessage/ErrorMessage';

const SalesOrderPage: React.FC = () => {
  const { salesOrderId } = useParams({
    from: '/authenticated/sales-orders/$salesOrderId',
  });
  const { data, isLoading, error } = useSalesOrder(salesOrderId);

  if (isLoading) {
    return (
      <Page>
        <MDBox display="flex" justifyContent="center" p={3}>
          <CircularProgress />
        </MDBox>
      </Page>
    );
  }

  if (error || !data?.salesOrder) {
    return (
      <Page>
        <MDBox display="flex" justifyContent="center" p={3}>
          <ErrorMessage error={error} />
        </MDBox>
      </Page>
    );
  }

  return (
    <Page>
      <SalesOrderView salesOrder={data?.salesOrder} />
    </Page>
  );
};

export default SalesOrderPage;
